import { ValueOf } from "@/types/type";

// Prebuild - 스튜디오 ai-video-jobs 컬렉션에 저장되는 Prebuild 이름
const TRANSLATE_VIDEO = "translateVideo";
const PROOFREAD_VIDEO = "proofreadVideo";
const EXPORT_PROOFREAD_VIDEO = "exportProofreadVideo";

export const PREBUILD = {
    TRANSLATE: TRANSLATE_VIDEO,
    PROOFREAD: PROOFREAD_VIDEO,
    EXPORT_PROOFREAD: EXPORT_PROOFREAD_VIDEO
} as const;

export const PREBUILD_OPTIONS = Object.values(PREBUILD);

export type TranslatevideoPrebuild = typeof PREBUILD_OPTIONS[number];

// Automation Plan Key - 자동화 데이터베이스에 저장된 이름이므로 수정 시 모든 환경 DB에 적용 필요
const TRANSLATE_VIDEO_PLAN = "translate_video";
const DUBBING_VIDEO_PLAN = "dubbing_video";
const TRANSLATE_WITH_PROOFREAD_PLAN = "translate_video_with_proofread";
const DUBBING_WITH_PROOFREAD_PLAN = "dubbing_video_with_proofread";
const EXPORT_TRANSLATE_WITH_PROOFREAD_PLAN = "export_translate_video_with_proofread";
const EXPORT_DUBBING_WITH_PROOFREAD_PLAN = "export_dubbing_video_with_proofread";

export const PLAN_KEY = {
    TRANSLATE_VIDEO: TRANSLATE_VIDEO_PLAN,
    DUBBING_VIDEO: DUBBING_VIDEO_PLAN,
    TRANSLATE_WITH_PROOFREAD: TRANSLATE_WITH_PROOFREAD_PLAN,
    DUBBING_WITH_PROOFREAD: DUBBING_WITH_PROOFREAD_PLAN,
    EXPORT_TRANSLATE_WITH_PROOFREAD: EXPORT_TRANSLATE_WITH_PROOFREAD_PLAN,
    EXPORT_DUBBING_WITH_PROOFREAD: EXPORT_DUBBING_WITH_PROOFREAD_PLAN,
}

// proofread 설정 없는 기본 플랜
export const DEFAULT_PLAN_KEYS = [
    TRANSLATE_VIDEO_PLAN,
    DUBBING_VIDEO_PLAN,
]

// proofread 설정 있는 플랜
export const PROOFREAD_PLAN_KEYS = [
    TRANSLATE_WITH_PROOFREAD_PLAN,
    DUBBING_WITH_PROOFREAD_PLAN,
];

// proofread 이후 export 플랜
export const EXPORT_PLAN_KEYS = [
    EXPORT_TRANSLATE_WITH_PROOFREAD_PLAN,
    EXPORT_DUBBING_WITH_PROOFREAD_PLAN,
];


export const PROOFREAD_STEP = {
    TRANSCRIPTION: "TRANSCRIPTION",
    TRANSLATION: "TRANSLATION",
    DUBBING: "DUBBING",
} as const


const PREPROCESS_ERROR = "Preprocess error.";
const STT_ERROR = "Speech tracking failed.";
const SPEAKER_SCENES_ERROR = "Speaker matching error.";
const TTS_ERROR = "Translation speech error.";
const ADJUST_ERROR = "Adjust translated audio error.";
const MIXING_AUDIO_ERROR = "Mixing total audio error.";
const MERGE_VIDEO_ERROR = "Merge dubbing audio to video error.";
const UPLOAD_S3_ERROR = "Upload resources error.";
const EXPORT_WEBHOOK_ERROR = "Export dubbing video error.";

export const DEFAULT_ERROR = "An error occurred while processing your request. Please try again later or\n" +
    "contact support if the issue persists.";

export const PROOFREAD_ERROR = {
    [PREPROCESS_ERROR]: "Unsupported file format. Please try again later or contact support.",
    [STT_ERROR]: "Unable to analyze speech. Please check your file and try again.",
    [SPEAKER_SCENES_ERROR]: "Unable to match speakers with the audio. Please check your file and try again.",
    [TTS_ERROR]: "An error occurred during speech translation. Please try again later or contact\n" +
    "support.",
    [ADJUST_ERROR]: "Failed to process translated audio. Please try again later or contact support.",
    [MIXING_AUDIO_ERROR]: "Audio mixing failed due to a system error. Please try again later or contact\n" +
    "support.",
    [MERGE_VIDEO_ERROR]: "Failed to merge dubbed audio with the video. Please try again later or contact\n" +
    "support.",
    [UPLOAD_S3_ERROR]: "Failed to upload resources. Please try again later or contact support.",
    [EXPORT_WEBHOOK_ERROR]: "Export failed due to a system issue. Please try again later or contact support.",
    DEFAULT: DEFAULT_ERROR,
} as const

export type ProofreadStep = ValueOf<typeof PROOFREAD_STEP>;